import { defineIntegration, consoleSandbox } from '@sentry/core';

const fetchStreamPerformanceIntegrationShim = defineIntegration(() => {
  consoleSandbox(() => {
    console.warn("You are using fetchStreamPerformanceIntegration() even though this bundle does not include tracing.");
  });
  return {
    name: "FetchStreamPerformance"
  };
});

export { fetchStreamPerformanceIntegrationShim };
//# sourceMappingURL=FetchStreamPerformance.js.map
